import { ReportAnalyticsEvent, mockedReportAnalyticsEvent } from '@ms/yammer-telemetry';
import { createContext } from 'react';

export interface TelemetryOptions {
  readonly reportAnalyticsEvent: ReportAnalyticsEvent;
}

export const defaultOptions: TelemetryOptions = {
  reportAnalyticsEvent: mockedReportAnalyticsEvent,
};

const TelemetryContext = createContext(defaultOptions);
export const TelemetryContextProvider = TelemetryContext.Provider;
